import { TFunction } from 'i18next';
import { ComponentSettingsKpiChart, validateHeight } from '@report-content';

export default function validateKpiChart(newSettings: ComponentSettingsKpiChart, t: TFunction) {
    let message = validateHeight(newSettings, t);

    if (-1 != newSettings.measureFields.findIndex((b) => b.reference_name == newSettings.x_axis.field)) {
        message = t('kpi_chart.validation.error_date_column_can_not_be_used_in_measure');
    }

    if (
        !message &&
        newSettings.stoplight.includeStoplight == 'Y' &&
        newSettings.stoplight.stoplightCalcMethod == 'target comparison' &&
        newSettings.stoplight.stoplightTarget?.reference_name == newSettings.x_axis.field
    ) {
        message = t('kpi_chart.validation.error_date_column_can_not_be_used_as_target');
    }

    if (
        !message &&
        newSettings.kpiVariance.includeKpiVariance == 'Y' &&
        newSettings.kpiVariance.varianceCalcMethod == 'target comparison' &&
        newSettings.kpiVariance.varianceTarget?.reference_name == newSettings.x_axis.field
    ) {
        message = t('kpi_chart.validation.error_date_column_can_not_be_used_as_target');
    }

    if (
        !message &&
        newSettings.stoplight.includeStoplight == 'Y' &&
        newSettings.stoplight.stoplightCalcMethod == 'target comparison' &&
        !newSettings.stoplight.stoplightTarget?.reference_name
    ) {
        message = t('kpi_chart.validation.error_target_not_selected');
    }

    if (
        !message &&
        newSettings.kpiVariance.includeKpiVariance == 'Y' &&
        newSettings.kpiVariance.varianceCalcMethod == 'target comparison' &&
        !newSettings.kpiVariance.varianceTarget?.reference_name
    ) {
        message = t('kpi_chart.validation.error_target_not_selected');
    }

    return message;
}
